import { AlgoliaMatchTypes } from '@/enums/AlgoliaMatchTypes';
import { IHighlightedSpeaker } from '@/resources/ThinLecture';
import { ThinProfile } from '@/resources/ThinProfile';

export const getHighlightedSpeakerFullName = (speaker: IHighlightedSpeaker) => {
  return `${speaker?.firstName?.value || ''} ${speaker?.lastName?.value || ''}`.trim();
};

export const getSpeakerFullName = (speaker: ThinProfile) => speaker && `${speaker.firstName} ${speaker.lastName}`;

const evaluateMatchLevel = (matchLevel) => {
  if (matchLevel === AlgoliaMatchTypes.Full) {
    return 2;
  }
  if (matchLevel === AlgoliaMatchTypes.Partial) {
    return 1;
  }

  return 0;
};

function getSpeakerMatchValue(speaker) {
  const firstNameScore = evaluateMatchLevel(speaker?.firstName?.matchLevel);
  const lastNameScore = evaluateMatchLevel(speaker?.lastName?.matchLevel);

  return firstNameScore + lastNameScore;
}

export function sortSpeakersByMatchValueComparator(a, b) {
  // 1) full match on first and last name
  // 2) full match on last name
  // 3) full match on first name
  // 3) partial match on last name
  // 3) partial match on first name
  // 4) none match

  const aMatchScore = getSpeakerMatchValue(a);
  const bMatchScore = getSpeakerMatchValue(b);

  if (aMatchScore > bMatchScore) {
    return -1;
  }
  if (aMatchScore < bMatchScore) {
    return 1;
  }
  return 0;
}
